import React from 'react';
import { PAGE_CODE } from '@/config/config';
import './style/base.scss';
import './style/pc.scss';
import './style/wap.scss';

interface IProps {
    code: number;
}
function index({ code }: IProps): JSX.Element {
    const renderContent = {
        [PAGE_CODE.NO_VIP]: <span className="txt">非常抱歉，您尝试访问的是VIP专属客服通道</span>,
        [PAGE_CODE.NO_FOUND]: <span className="txt">抱歉，您访问的页面不存在</span>,
        [PAGE_CODE.NO_START]: <span className="txt">很抱歉，客服服务未上架</span>,
        [PAGE_CODE.ENDED]: <span className="txt">很抱歉，客服服务已下架</span>,
        [PAGE_CODE.CLOSED]: <span className="txt">很抱歉，客服服务已下架</span>,
        default: <span className="txt">很抱歉，您访问的页面不存在</span>
    };
    return (
        <div className="default-wrapper">
            <i className="default-icon" />
            {renderContent[code] || renderContent.default}
        </div>
    );
}

export default index;
